import React, { FC } from 'react';
import classNames from 'classnames';
import classes from './styles/index.module.scss';

type CounterProps = {
	blue?: boolean;
	green?: boolean;
	gray?: boolean;
	red?: boolean;
	yellow?: boolean;
	className?: string;
	dataTestId?: string;
};

export const Counter: FC<React.PropsWithChildren<CounterProps>> = ({
	blue,
	yellow,
	red,
	green,
	gray,
	className,
	dataTestId,
	children,
}) => {
	const componentClasses = classNames(className, classes.counter, {
		[classes.counter_blue]: blue,
		[classes.counter_yellow]: yellow,
		[classes.counter_red]: red,
		[classes.counter_green]: green,
		[classes.counter_gray]: gray,
	});

	return (
		<span
			className={componentClasses}
			data-testid={dataTestId}
		>
			{children}
		</span>
	);
};
